module.exports = __webpack_public_path__ + "img/heat_recovery.f387dada.png";